<template>
  <div
    class="rectangle"
    :class="[
      { 
        colorfull: colorFull, 
        roundedd: rounded, 
        'no-border': noBorder, 
        magnify, 
        'no-shadow': noShadow ,
        'dark-text': darkText,
      },
       bgColor]">
    <i v-if="icon" :class="icon" class="mr-2"></i>
    {{ title }}
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'rectangle',

  props: {
    // eslint-disable-next-line vue/require-default-prop
    title: {
      type: [String, Number],
      require: true,
    },
    bgColor: {
      type: String,
      default: 'primary',
    },
    colorFull: {
      type: Boolean,
      default: false,
    },
    rounded: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: '',
    },
    magnify: {
      type: Boolean,
      default: false,
    },
    noBorder: {
      type: Boolean,
      default: false,
    },
    noShadow: {
      type: Boolean,
      default: false,
    },
    darkText: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      roundedValue: '',
      textColor: 'white',
    }
  },

  mounted() {
    if (this.rounded) {
      this.roundedValue = 'rounded'
    }
    if (this.bgColor === 'light') {
      this.textColor = 'dark'
    }
  },
}
</script>

<style scoped></style>
